module.exports = __webpack_public_path__ + "static/media/decoration.98a90635.svg";